import { render, staticRenderFns } from "./ChatroomUploadFile.vue?vue&type=template&id=2b5cf910&scoped=true"
import script from "./ChatroomUploadFile.vue?vue&type=script&lang=js"
export * from "./ChatroomUploadFile.vue?vue&type=script&lang=js"
import style0 from "./ChatroomUploadFile.vue?vue&type=style&index=0&id=2b5cf910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5cf910",
  null
  
)

export default component.exports